<template>
  <div class="is-flex is-justify-content-center py-6 px-4">
    <div class="container" :style="{maxWidth: '520px'}">

      <div class="py-2">
        <div class="is-flex is-justify-content-center" v-if="getLogoEmail">
          <figure class="image is-128x128">
            <img :src="getLogoEmail" alt="Logo" />
          </figure>
        </div>
        <div class="field">
          <label class="label" for="tourPassword">Password</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="tourPassword"
              id="tourPassword"
              placeholder="Type password..."
              @keyup.enter="verifyPassword"
            />
          </div>
        </div>

        <button
          type="button"
          class="button is-dark"
          @click="verifyPassword"
        >
          Access
        </button>
        <div v-if="passwordInvalid" class="has-text-danger mt-1">Invalid password</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import config from '@/config'

  export default {
    data () {
      return {
        tourPassword: '',
        passwordInvalid: false
      }
    },
    computed: {
      ...mapGetters(
        'tour', [
          'getId',
          'getAccess',
          'getLogoEmail'
        ]
      ),
    },
    methods: {
      verifyPassword() {
        this.passwordInvalid = false;

        fetch(`${config.API_URL}/password/verify`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            tourId: this.getId,
            password: this.tourPassword,
            type: 'tour',
            tourPasswordOneTime: this.getAccess.tourPasswordOneTime
          })
        })
          .then((res) => res.json())
          .then(res => {
            if (res.status === 'failure') {
              this.passwordInvalid = true;
            } else {
              this.$emit('onVerifiedPassword', true);
            }
          }).catch(err => {
            console.log(err);
            this.passwordInvalid = true;
          });
      }
    }
  };
</script>

<style lang="scss">
  @charset "utf-8";

  @import url("https://fonts.googleapis.com/css?family=Fira+Sans:400,700&subset=latin-ext");

  @import "../assets/styles/mixins";

  $family-sans-serif: 'Fira Sans', sans-serif;

  @import "~bulma/sass/utilities/_all.sass";
  @import "~bulma/sass/base/_all.sass";
  @import "~bulma/sass/elements/_all.sass";
  @import "~bulma/sass/form/_all.sass";
  @import "~bulma/sass/helpers/_all.sass";
</style>
